export enum YearInMalta {
  NONE = '0',
  LESS_THAN_5_YEARS = '1',
  MORE_THAN_5_YEARS = '2',
}
